import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';

const SearchCount = ({ count, clang }) => {
    return (
        <div className="search-info">
            <div className="search-info__content">
                <p className="search-info__key">{lang[clang].search.count}: <strong>{numberWithSpaces(count)}</strong></p>
            </div>
        </div>
    );
};

SearchCount.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SearchCount);



// WEBPACK FOOTER //
// ./src/components/search/SearchCount.js